import axios from 'axios';
import { Category } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const createApiInstance = () => {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        },
    });
};

export const categoryAPI = {
    createCategory: async (category: Partial<Category>): Promise<Category> => {
        const api = createApiInstance();
        const response = await api.post('/categories', category);
        return response.data;
    },

    updateCategory: async (id: string, category: Partial<Category>): Promise<Category> => {
        const api = createApiInstance();
        const response = await api.put(`/categories/${id}`, category);
        return response.data;
    },

    getCategoriesByCompany: async (companyId: string): Promise<Category[]> => {
        const api = createApiInstance();
        const response = await api.get(`/categories/company/${companyId}`);
        return response.data;
    },

    getCategoryById: async (id: string): Promise<Category> => {
        const api = createApiInstance();
        const response = await api.get(`/categories/${id}`);
        return response.data;
    },

    deleteCategory: async (id: string): Promise<void> => {
        const api = createApiInstance();
        await api.delete(`/categories/${id}`);
    },
};
